import { images } from './images';
import type { CardProps } from './PromoSection/Card';

export const cards: CardProps[] = [
    {
        organization: {
            name: 'E заем',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e95f52f21f302001b3230bc.svg?v=0.52',
            },
        },
        title: 'Бонусная программа',
        text: 'Программа лояльности. Скидки до 25% за возвращенные займы.',
        backgroundColor: '#EF883F',
        textColor: '#FFF',
        promoLink: 'https://www.ezaem.ru/bonusy/',
    },
    {
        organization: {
            name: 'Moneza',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e95d8e121f302001b3230ac.svg?v=0.24',
            },
        },
        title: 'Бонусная программа',
        text: 'Возможность получить кэшбэк до 20% за погашенные займы.',
        backgroundColor: '#413BF5',
        textColor: '#fff',
        promoLink: 'https://www.moneza.ru/bonusy/',
    },
    {
        organization: {
            name: 'Финтерра',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e96b604704b14001b773bd4.svg?v=0.a8',
            },
        },
        title: 'Гарантия низкой ставки',
        text:
            'Акция действует при предъявлении открытого или закрытого договора потребительского займа другого МФО. Скидка 0,1% от ставки иной МФО, при предъявлении договора потребительского займа. Минимальная ставка в рамках уведомления к договору займа составляет 182,50% годовых (0,5% в день).',
        backgroundColor: '#FFC446',
        textColor: '#171D23',
        promoLink:
            'https://xn--80ajiuqaln.xn--p1ai/%D0%B0%D0%BA%D1%86%D0%B8%D0%B8/%D0%B3%D0%B0%D1%80%D0%B0%D0%BD%D1%82%D0%B8%D1%8F-%D0%BD%D0%B8%D0%B7%D0%BA%D0%BE%D0%B9-%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B8',
    },
    {
        organization: {
            name: 'Надо денег',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5f477a533c93d6009b45d6bc.svg?v=0.08',
            },
        },
        title: 'Промокод на апрель',
        text: 'Скидка 10% на оформление займа при указании промокода: SM10.',
        backgroundColor: '#DAE9DB',
        textColor: '#171D23',
        promoLink:
            'https://nadodeneg.ru/?utm_source=sravni_new&utm_medium=affiliate&utm_campaign=sravni-new_cps&utm_term=0e691502-403d-47b6-a470-99fc3e6817bf&click_id=1022b51c366d97470a334dea642037',
    },
    {
        organization: {
            name: 'Moneyman',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e5fbbef55e6a6001b03fab6.svg?v=0.37',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.moneymanGirl} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.moneymanGirl} {...props} />,
        title: 'Бонусная программа',
        text: 'Можно получать бонусные рубли MoneyMan за закрытый заём или оставленный отзыв.',
        backgroundColor: '#FFC446',
        textColor: '#171D23',
        promoLink: 'https://moneyman.ru/programm/',
    },
    {
        organization: {
            name: 'Быстроденьги',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9da1bd8adc27001b7f27bb.svg?v=0.00',
            },
        },
        title: 'Приведи друга с ПТС',
        text:
            'Нужно поделиться с друзьями и родными о том, что они могут оформить заём в компании «Быстроденьги» под залог ПТС и получить до 1 000 000 рублей. И если заём будет выдан по вашей рекомендации – «Быстроденьги» заплатит 1500 или 2000 рублей.',
        backgroundColor: '#4193E2',
        textColor: '#fff',
        promoLink: 'https://bistrodengi.ru/promo/privedi-druga-s-pts-poluchi-1500-rubley/',
    },
    {
        organization: {
            name: 'ЭкспрессДеньги',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5ea08ef53cfcf7001b146b41.svg?v=0.9d',
            },
        },
        title: 'Клубные карты',
        text: 'Для обладателей карт услуги компании со скидкой до 40% и сниженные ставки по займам.',
        backgroundColor: '#00B0B9',
        textColor: '#fff',
        promoLink: 'https://xn--c1abcbqhymjida0md.xn--p1ai/club/',
    },
    {
        organization: {
            name: 'Webbankir',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e95c820380d2c001c873e36.svg?v=0.bd',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.webbankirGirl} {...props} />,
        title: 'Кэшбэк для своих',
        text:
            'Участвуйте в программе лояльности и получайте кешбэк. 5% бонусных баллов будут начислены от суммы уплаченных процентов. Бонусы можно потратить на погашение займа.',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink: 'https://webbankir.com/cashback',
    },
    {
        organization: {
            name: 'Конга',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9b1b6b704b14001b773c3e.svg?v=0.03',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.gorilla} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.gorilla} {...props} />,
        title: 'Программа лояльности',
        text: 'Скидки на последующие займы от 4% до 20% при подключении к программе лояльности.',
        backgroundColor: '#3062B9',
        textColor: '#fff',
        promoLink: 'https://www.konga.ru/loyalty',
    },
    {
        organization: {
            name: 'Касса Взаимопомощи',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9f387fc412db001c7b8d46.svg?v=0.16',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.aquarium} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.aquarium} {...props} />,
        title: 'Друзья офлайн',
        text: 'Приводи друзей и получай 1 000 рублей за каждого!',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink: 'https://kreditkassa.ru/sale-list',
    },
    {
        organization: {
            name: 'Ваш инвестор',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/60d5b3294eda370021a28355.svg?v=0.24',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.yourInvestor} {...props} />,
        title: 'Клуб «100 друзей»',
        text: 'За рекомендацию друзьям и знакомым, можно получить до 9000 рублей за каждую сделку по рекомендации.',
        backgroundColor: '#1B1B1A',
        textColor: '#fff',
        promoLink: 'https://vashinvestor.ru/100-druzej/',
    },
    {
        organization: {
            name: 'Webbankir',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e95c820380d2c001c873e36.svg?v=0.bd',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.heartGirl} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.heartGirl} {...props} />,
        title: 'Кешбэк за отзыв о WEBBANKIR на Sravni.ru',
        text: 'Кешбэк 500 руб в личный кабинет за отзыв о WEBBANKIR на Sravni.ru.',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink:
            'https://webbankir.com/offers/poluchite-keshbek-500-rub-v-lichnyj-kabinet-za-otzyv-o-webbankir-na-sravni-ru',
    },
    {
        organization: {
            name: 'Центрофинанс',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e99806f8adc27001b7f2734.svg?v=0.c5',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.bonusGirl} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.bonusGirl} {...props} />,
        title: 'Бонусная программа',
        text: 'Возвращают до 10% c процентов по займу, зависит от суммарного количества дней пользования займами.',
        backgroundColor: '#E6EDF4',
        textColor: '#171D23',
        promoLink: 'https://centrofinans.ru/promo-c-bonus/',
    },
    {
        organization: {
            name: 'Деньгимигом',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9709428adc27001b7f26e0.svg?v=0.d4',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.finishZero} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.finishZero} {...props} />,
        title: 'Первый заём под 0%',
        text: 'Первые 10 дней займа бесплатно. Общий срок займа фиксирован — 30 дней.',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink: 'https://dengimigom.ru/promotions/',
    },
    {
        organization: {
            name: 'Срочноденьги',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9838a88adc27001b7f2702.svg?v=0.7b',
            },
        },
        title: 'День Рождения',
        text:
            'Оформляя заём в свой день рождения или своего ребенка, за два дня до или после — на заём действует скидка 50%.',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink: 'https://srochnodengi.ru/loyaltyprogram/den_rozhdeniya/',
    },
    {
        organization: {
            name: 'МикроКлад',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9d52ac704b14001b773c9d.svg?v=0.b4',
            },
        },
        title: 'Бонусная программа',
        text:
            'Баллы начисляются за совершение платежей для погашения займа, а так же за выдачу займа приглашенным друзьям, которые зарегистрировались по QR-коду из личного кабинета клиента.',
        backgroundColor: '#6A2524',
        textColor: '#fff',
        promoLink: 'https://microklad.ru/bonuses',
    },
    {
        organization: {
            name: 'Быстроденьги',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9da1bd8adc27001b7f27bb.svg?v=0.00',
            },
        },
        title: 'Скидка 25% на заём',
        text:
            'Для действующих клиентов. В честь Дня рождения оформите заём на сумму от 1 000 до 30 000 рублей по сниженной ставке 0,6%.',
        backgroundColor: '#4193E2',
        textColor: '#fff',
        promoLink: 'https://bistrodengi.ru/promo/darim-skidku-20-na-zaym-v-chest-dnya-rozhdeniya/',
    },
    {
        organization: {
            name: 'Финтерра',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e96b604704b14001b773bd4.svg?v=0.a8',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.balloon} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.balloon} {...props} />,
        title: 'День Рождения',
        text:
            'Ставка - 0,7% для новых и повторных клиентов. Действует в течение 3х календарных дней до дня рождения и в день рождения.',
        backgroundColor: '#9E0E72',
        textColor: '#FFF',
        promoLink:
            'https://xn--80ajiuqaln.xn--p1ai/%D0%B0%D0%BA%D1%86%D0%B8%D0%B8/%D0%B4%D0%B5%D0%BD%D1%8C-%D1%80%D0%BE%D0%B6%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F',
    },
    {
        organization: {
            name: 'ДоброЗайм',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9b21d68adc27001b7f2755.svg?v=0.e8',
            },
        },
        title: 'Приведи друга',
        text: 'Бонус 1000 рублей.',
        backgroundColor: '#DAE9DB',
        textColor: '#171D23',
        promoLink: 'https://dobrozaim.ru/friend/#w_referring_place=green_menu',
    },
    {
        organization: {
            name: 'Центрофинанс',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e99806f8adc27001b7f2734.svg?v=0.c5',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.rockStars} {...props} />,
        mobileBackgroundImage: (props) => <img src={images.mobile.rockStars} {...props} />,
        title: 'Для друзей',
        text: 'Дарим 1 000 бонусов за каждого друга, который оформит заём по вашей рекомендации.',
        backgroundColor: '#E6EBF7',
        textColor: '#171D23',
        promoLink: 'https://centrofinans.ru/akcii/aktsiya-dlya-druzey/',
    },
    {
        organization: {
            name: 'Joymoney',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e95f200380d2c001c873e4b.svg?v=0.e9',
            },
        },
        title: 'Мега старт',
        text:
            'Для новых клиентов. При оплате займа до 10 000 рублей в течение 21 дня, будет действовать льготный период со ставкой 0%. Договор займа оформляется от 10 дней.',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink: 'https://joy.money/',
    },
    {
        organization: {
            name: 'Срочноденьги',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e9838a88adc27001b7f2702.svg?v=0.7b',
            },
        },
        title: 'Приведи друга',
        text:
            'Рекомендуя своим друзьям заём в ООО МКК «Срочноденьги», за каждый оформленный договор заемщику и другу будет начислено по 500, 1000 или 2000 бонусных рублей (в зависимости от суммы займа), которыми можно погашать проценты.',
        backgroundColor: '#fff',
        textColor: '#171D23',
        promoLink: 'https://srochnodengi.ru/loyaltyprogram/privedi_druga/',
    },
    {
        organization: {
            name: 'Центрофинанс',
            logotypes: {
                android:
                    'https://s91588.cdn.ngenix.net/organizations/logotypes/android/5e99806f8adc27001b7f2734.svg?v=0.c5',
            },
        },
        desktopBackgroundImage: (props) => <img src={images.desktop.birthdayGirl} {...props} />,
        title: 'День рождения',
        text:
            'Оформите заём на день рождения и получите 500 бонусных рублей на свой счёт. Акция действует 7 дней: в день рождения и в течение трёх дней до и после него. ',
        backgroundColor: '#EFF3F7',
        textColor: '#171D23',
        promoLink: 'https://centrofinans.ru/akcii/aktsiya-den-rozhdeniya/',
    },
];
